// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable import/named */

import { useControl } from "react-map-gl/mapbox";
import { MapboxOverlay, MapboxOverlayProps } from "@deck.gl/mapbox";

export const DeckGLOverlay = (props: MapboxOverlayProps) => {
	const overlay = useControl<MapboxOverlay>(() => new MapboxOverlay(props));
	overlay.setProps(props);
	return null;
};
